import _ from 'underscore';

const options = {
  raw: 'yyyy-MM-dd',
  timeZone: null,
};

export function getSelectionDateFormatter(i18n) {
  return i18n.dateFormatter(options);
}

export function getSelectionDateParser(i18n) {
  const parser = i18n.dateParser(options);

  return date => (_.isString(date) ? parser(date.substr(0, 10)) : undefined);
}
